module.exports = __webpack_public_path__ + "static/media/Test.336fbbb0.jpg";